module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/oleksandr-zozulinskiy-bkg-e664147e2ce12e31429c7ed881719fcf.jpg";